import { render, staticRenderFns } from "./FiberOpticsViz.vue?vue&type=template&id=135c9e29&scoped=true"
import script from "./FiberOpticsViz.vue?vue&type=script&lang=js"
export * from "./FiberOpticsViz.vue?vue&type=script&lang=js"
import style0 from "./FiberOpticsViz.vue?vue&type=style&index=0&id=135c9e29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c9e29",
  null
  
)

export default component.exports